<template>
  <div id="container">
    <el-card class="box-card"
             shadow="never">
      <div class="pb20">
        <el-link type="primary"
                 @click.prevent="goBack"
                 :underline="false"
                 style="color: #276CFF"
        >
          <i class="el-icon-arrow-left"></i>
          返回
        </el-link>
      </div>
      <el-card class="box-card"
               shadow="never"
               style="background-color: #F6F7FB;margin-bottom: 20px;"
      >
        <div class="collect_icon"
             v-if="noticeDetailsObj.noticeType === '重要'">
          <span class="iconfont icon-gongzuotai-gonggao-chakan-zhongyao" style="font-size: 30px;color:#D35E5E"></span>
        </div>
        <h3 style="text-align: center">{{noticeDetailsObj.noticeTitle}}</h3>
        <el-card class="box-card"
                 shadow="never"
                 style="background-color: #F6F7FB"
                 v-html="noticeDetailsObj.noticeContent"
        >
        </el-card>
        <el-row>
          <el-col :span="4"
                  :offset="20">
            <h6 class="notice_issuer">{{noticeDetailsObj.issuer}}</h6>
            <div class="notice_timer">{{noticeDetailsObj.createDate | formatDate}}</div>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="never"
               class="notice_file">
        <div slot="header">
          <div><i class="el-icon-paperclip"
                  style="color: #3E7DEB"></i> 附件 <span
            v-if="noticeDetailsObj.systemNoticeAttachmentList && noticeDetailsObj.systemNoticeAttachmentList.length !== 0">({{noticeDetailsObj.systemNoticeAttachmentList.length}}个)</span>
          </div>
        </div>
        <div v-if="noticeDetailsObj.systemNoticeAttachmentVoList.length !== 0">
          <div class="file_list"
               v-for="(item,index) in systemNoticeAttachmentVoList"
               :key="index">
            <div class="file_icon">
              <svg t="1600911106422" v-if="item.iconClass === 'excel'" style="font-size:30px;" class="icon"
                   viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1459" width="30"
                   height="30">
                <path
                  d="M188.614194 1007.219613a6.804645 6.804645 0 0 1-6.804646-6.771613V20.347871c0-3.732645 3.072-6.771613 6.804646-6.771613h770.411354c3.732645 0 6.804645 3.038968 6.804646 6.771613v980.067097a6.804645 6.804645 0 0 1-6.804646 6.804645H188.614194z"
                  fill="#FFFFFF" p-id="1460"></path>
                <path
                  d="M959.025548 16.945548c1.882839 0 3.402323 1.552516 3.402323 3.402323v980.067097a3.402323 3.402323 0 0 1-3.402323 3.402322H188.614194a3.402323 3.402323 0 0 1-3.402323-3.36929V20.347871c0-1.849806 1.519484-3.402323 3.402323-3.402323h770.411354m0-6.771613H188.614194a10.173935 10.173935 0 0 0-10.173936 10.173936v980.067097c0 5.648516 4.525419 10.206968 10.173936 10.206967h770.411354c5.615484 0 10.173935-4.558452 10.173936-10.173935V20.347871a10.173935 10.173935 0 0 0-10.173936-10.173936z"
                  fill="#DEDEDE" p-id="1461"></path>
                <path
                  d="M858.376258 319.587097H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804646h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804646v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804646v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804646z"
                  fill="#E5E5E5" p-id="1462"></path>
                <path
                  d="M501.000258 195.815226a31.050323 31.050323 0 0 1 31.215484 30.951226v567.229935a31.050323 31.050323 0 0 1-31.215484 30.951226l-416.206452-41.25729a31.050323 31.050323 0 0 1-31.215483-30.918194V268.023742a31.050323 31.050323 0 0 1 31.215483-30.951226zM240.144516 388.360258H192.412903l73.232516 131.699613L187.623226 660.645161h45.518451l34.782968-67.716129c6.639484-13.675355 13.312-27.747097 21.074581-44.395355h1.486451c8.48929 16.648258 15.525161 30.72 22.561033 44.395355L348.88671 660.645161h47.731613l-78.418581-138.372129 73.232516-133.912774H346.310194l-32.17342 63.620129c-6.276129 12.58529-11.495226 24.774194-18.498064 41.059097h-1.849807c-8.158968-16.251871-14.071742-28.473806-20.744258-41.059097l-32.900129-63.620129z"
                  fill="#139E2A" p-id="1463"></path>
              </svg>
              <svg t="1600911249974" v-if="item.iconClass === 'pdf'" style="font-size:30px;" class="icon"
                   viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1617" width="30"
                   height="30">
                <path
                  d="M188.614194 1007.219613a6.804645 6.804645 0 0 1-6.804646-6.771613V20.347871c0-3.732645 3.072-6.771613 6.804646-6.771613h770.411354c3.732645 0 6.804645 3.038968 6.804646 6.771613v980.067097a6.804645 6.804645 0 0 1-6.804646 6.804645H188.614194z"
                  fill="#FFFFFF" p-id="1618"></path>
                <path
                  d="M959.025548 16.945548c1.882839 0 3.402323 1.552516 3.402323 3.402323v980.067097a3.402323 3.402323 0 0 1-3.402323 3.402322H188.614194a3.402323 3.402323 0 0 1-3.402323-3.36929V20.347871c0-1.849806 1.519484-3.402323 3.402323-3.402323h770.411354m0-6.771613H188.614194a10.173935 10.173935 0 0 0-10.173936 10.173936v980.067097c0 5.648516 4.525419 10.206968 10.173936 10.206967h770.411354c5.615484 0 10.173935-4.558452 10.173936-10.173935V20.347871a10.173935 10.173935 0 0 0-10.173936-10.173936z"
                  fill="#DEDEDE" p-id="1619"></path>
                <path
                  d="M858.376258 319.587097H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804646h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804646v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804646v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804646z"
                  fill="#E5E5E5" p-id="1620"></path>
                <path
                  d="M84.793806 237.072516a31.050323 31.050323 0 0 0-31.215483 30.951226v484.748387a31.050323 31.050323 0 0 0 31.215483 30.918194l416.206452 41.25729a31.050323 31.050323 0 0 0 31.215484-30.951226V226.766452a31.050323 31.050323 0 0 0-31.215484-30.951226l-416.206452 41.290322z"
                  fill="#F25022" p-id="1621"></path>
                <path
                  d="M310.338065 396.387097H214.709677v264.258064h59.392v-91.036903h30.852129c33.131355 0 59.358968-8.059871 78.616775-24.939355 19.290839-16.152774 29.332645-38.18529 29.332645-64.611097C412.903226 424.266323 378.219355 396.387097 310.338065 396.387097z m-10.801549 127.735742h-25.434839v-82.250323h25.434839c32.371613 0 48.557419 13.212903 48.557419 40.398452 0 28.638968-16.185806 41.851871-48.557419 41.851871z"
                  fill="#FFFFFF" p-id="1622"></path>
              </svg>
              <svg t="1600911263366" v-if="item.iconClass === 'word'" style="font-size:30px;" class="icon"
                   viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1806" width="30"
                   height="30">
                <path
                  d="M188.614194 1007.219613a6.804645 6.804645 0 0 1-6.804646-6.771613V20.347871c0-3.732645 3.072-6.771613 6.804646-6.771613h770.411354c3.732645 0 6.804645 3.038968 6.804646 6.771613v980.067097a6.804645 6.804645 0 0 1-6.804646 6.804645H188.614194z"
                  fill="#FFFFFF" p-id="1807"></path>
                <path
                  d="M959.025548 16.945548c1.882839 0 3.402323 1.552516 3.402323 3.402323v980.067097a3.402323 3.402323 0 0 1-3.402323 3.402322H188.614194a3.402323 3.402323 0 0 1-3.402323-3.36929V20.347871c0-1.849806 1.519484-3.402323 3.402323-3.402323h770.411354m0-6.771613H188.614194a10.173935 10.173935 0 0 0-10.173936 10.173936v980.067097c0 5.648516 4.525419 10.206968 10.173936 10.206967h770.411354c5.615484 0 10.173935-4.558452 10.173936-10.173935V20.347871a10.173935 10.173935 0 0 0-10.173936-10.173936z"
                  fill="#DEDEDE" p-id="1808"></path>
                <path
                  d="M858.376258 319.587097H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804646h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804646v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804646v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804646z"
                  fill="#E5E5E5" p-id="1809"></path>
                <path
                  d="M501.000258 195.815226l-416.206452 41.290322a31.050323 31.050323 0 0 0-31.215483 30.918194v484.748387a31.050323 31.050323 0 0 0 31.215483 30.918194l416.206452 41.25729a31.050323 31.050323 0 0 0 31.215484-30.951226V226.766452a31.050323 31.050323 0 0 0-31.215484-30.951226z"
                  fill="#3A74D1" p-id="1810"></path>
                <path
                  d="M376.600774 394.306065c-9.744516 57.04671-19.885419 114.027355-29.299613 171.074064-11.56129-55.527226-22.759226-110.658065-33.593806-166.251355-15.591226 1.090065-30.753032 1.783742-46.344258 2.543484l-34.683871 161.197419c-7.597419-52.257032-17.011613-104.514065-25.368774-156.771096-14.071742 0.72671-28.242581 1.090065-41.950968 1.816774 12.651355 72.670968 28.242581 144.350968 41.950968 216.691613 15.624258 1.090065 31.479742 2.180129 47.070967 2.873806 10.867613-53.049806 23.518968-105.670194 32.900129-158.620903 9.447226 54.404129 22.032516 108.544 32.900129 162.981161 15.954581-1.090065 36.203355 6.243097 49.911742-0.726709 19.918452-79.310452 36.236387-159.710968 55.395097-239.31871-16.317935 1.057032-32.569806 1.816774-48.887742 2.510452z"
                  fill="#FFFFFF" p-id="1811"></path>
              </svg>
              <svg t="1600912782150" v-if="item.iconClass === 'img'" style="font-size:30px;" class="icon"
                   viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1527" width="30"
                   height="30">
                <path
                  d="M188.614194 1007.219613a6.804645 6.804645 0 0 1-6.804646-6.771613V20.347871c0-3.732645 3.072-6.771613 6.804646-6.771613h770.411354c3.732645 0 6.804645 3.038968 6.804646 6.771613v980.067097a6.804645 6.804645 0 0 1-6.804646 6.804645H188.614194z"
                  fill="#FFFFFF" p-id="1528"></path>
                <path
                  d="M959.025548 16.945548c1.882839 0 3.402323 1.552516 3.402323 3.402323v980.067097a3.402323 3.402323 0 0 1-3.402323 3.402322H188.614194a3.402323 3.402323 0 0 1-3.402323-3.36929V20.347871c0-1.849806 1.519484-3.402323 3.402323-3.402323h770.411354m0-6.771613H188.614194a10.173935 10.173935 0 0 0-10.173936 10.173936v980.067097c0 5.648516 4.525419 10.206968 10.173936 10.206967h770.411354c5.615484 0 10.173935-4.558452 10.173936-10.173935V20.347871a10.173935 10.173935 0 0 0-10.173936-10.173936z"
                  fill="#DEDEDE" p-id="1529"></path>
                <path
                  d="M858.376258 319.587097H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.771613 6.771613 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804645v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804646h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804646v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804645z m0 92.820645H382.909935a6.804645 6.804645 0 0 0-6.771612 6.804646v27.648c0 3.732645 3.038968 6.804645 6.771612 6.804645h475.466323a6.804645 6.804645 0 0 0 6.804645-6.804645v-27.648a6.804645 6.804645 0 0 0-6.804645-6.804646z"
                  fill="#E5E5E5" p-id="1530"></path>
                <path
                  d="M84.793806 237.072516a31.050323 31.050323 0 0 0-31.215483 30.951226v484.748387a31.050323 31.050323 0 0 0 31.215483 30.918194l416.206452 41.25729a31.050323 31.050323 0 0 0 31.215484-30.951226V226.766452a31.050323 31.050323 0 0 0-31.215484-30.951226l-416.206452 41.290322z"
                  fill="#F9B331" p-id="1531"></path>
                <path
                  d="M438.139871 627.612903H155.218581c-1.651613 0-4.954839-1.651613-6.57342-3.303226v-6.540387l60.84542-81.886967c1.651613-1.651613 3.303226-3.270194 6.606451-3.270194 1.651613 0 4.921806 1.651613 4.921807 3.303226l29.596903 42.545548L347.664516 432.722581c1.651613-1.651613 4.954839-3.270194 6.606452-3.270194 1.618581 0 4.888774 1.651613 6.540387 3.303226l83.901935 186.698322c1.651613 1.651613 1.651613 3.303226 0 4.921807-1.651613 1.651613-3.303226 3.270194-6.606451 3.270193z"
                  fill="#FFF7F7" p-id="1532"></path>
                <path
                  d="M247.741935 412.903226c0 26.425806-23.122581 49.548387-49.515354 49.548387-26.425806 0-49.482323-23.122581-49.482323-49.548387-1.651613-26.425806 21.437935-49.548387 49.482323-49.548387 26.425806 0 49.515355 23.122581 49.515354 49.548387z"
                  fill="#FFFFFF" p-id="1533"></path>
              </svg>
            </div>
            <div class="file_info">
              <div class="file_title">{{item.fileName}}</div>
              <div class="file_btn">
                <el-button type="text" @click="previewFile(item)">预览</el-button>
                <el-button
                  type="text"
                  @click="downloadFile(item.attaGuid)"
                >下载
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else
             style="text-align: center">
          <noData :style="{'padding':0}">暂无附件</noData>
        </div>
        <!--        <el-image-->
        <!--          style="width: 100px; height: 100px"-->
        <!--          :src="url"-->
        <!--          :preview-src-list="srcList">-->
        <!--        </el-image>-->
      </el-card>
      <el-card shadow="never" style="text-align: right;">
        <el-button type="text" @click="preNotice" :disabled="!lastSnId && lastSnId !== 0">上一条</el-button>
        <el-button type="text" :disabled="!nextSnId && nextSnId !== 0" @click="nextNotice">下一条</el-button>
      </el-card>
    </el-card>
    <base-dialog
      :dialog-visible.sync="fileDialogVisible"
      :width="`1200px`"
      :title="`文件预览`"
    >
      <div class="pb20">
        <iframe :src="fileUrl" frameborder="0" style="width: 100%;height:600px;"></iframe>
      </div>
    </base-dialog>
  </div>
</template>

<script>
import noticeApi from '@/api/workbench/notice'
import { downLoadFile, isSuccess } from '@/util/tool'
import { weekDay } from '@/meun/date'
import noData from '@/components/module/noData'
import checkApi from '@/api/workbench/check'

export default {
  name: 'noticeDetail',
  data () {
    return {
      noticeDetailsObj: {
        systemNoticeAttachmentVoList: []
      },
      url: '',
      srcList: [],
      snId: '',
      lastSnId: '',
      nextSnId: '',
      fileDialogVisible: false,
      fileUrl: ''
    }
  },
  components: { noData },
  computed: {
    systemNoticeAttachmentVoList () {
      return this.noticeDetailsObj.systemNoticeAttachmentVoList.map(item => {
        const fileTypeArr = item.fileName.split('.')
        const fileType = fileTypeArr[fileTypeArr.length - 1]
        switch (fileType) {
          case 'doc':
          case 'docx':
            item.iconClass = 'word'
            break
          case 'xls':
          case 'xlsx':
            item.iconClass = 'excel'
            break
          case 'pdf':
            item.iconClass = 'pdf'
            break
          default:
            item.iconClass = 'img'
        }
        return item
      })
    }
  },
  filters: {
    formatDate (data) {
      if (!data) return ''
      const date = new Date(data)
      return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日 ' + date.getHours() + '时' + date.getMinutes() + '分  ' + weekDay[date.getDay()]
    }
  },
  mounted () {
    this.snId = this.$route.query.snId
    this.queryNoticeDetail()
  },
  methods: {
    // 下一条公告
    nextNotice () {
      if (this.nextSnId) {
        this.queryNoticeDetail(this.nextSnId)
      }
    },
    // 上一条公告
    preNotice () {
      if (this.lastSnId) {
        this.queryNoticeDetail(this.lastSnId)
      }
    },
    // 获取公告详情
    queryNoticeDetail (snIdex) {
      let { snId } = this
      if (snIdex) {
        snId = snIdex
      }
      noticeApi.queryNoticeDetail({
        snId
      })
        .then(res => {
          if (isSuccess(res)) {
            this.noticeDetailsObj = res.data.obj
            this.lastSnId = res.data.obj.lastSnId
            this.nextSnId = res.data.obj.nextSnId
          } else {
            this.$message({
              message: res.data.msg
            })
          }
        })
    },
    // 下载文件
    downloadFile (guid) {
      noticeApi.downloadNoticeFile({
        guid
      }).then(res => {
        downLoadFile(res)
      })
    },
    // 预览文件
    previewFile (item) {
      const { attaGuid } = item
      this.fileUrl = ''
      checkApi.getPactFileUrl({ guid: attaGuid }).then(res => {
        if (isSuccess(res)) {
          this.fileUrl = this.$store.state.https + res.data.obj.filePath
          const filearr = res.data.obj.filePath && res.data.obj.filePath.split('.')
          const fileType = filearr[filearr.length - 1]
          this.fileDialogVisible = true
          if (fileType === 'pdf' || fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
            this.fileDialogVisible = true
          } else {
            this.fileUrl = 'http://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl
          }
          // window.open(this.$store.state.https + res.data.obj.filePath)
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .file_list {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }

  .file_list:last-child {
    padding-bottom: 0;
  }

  .file_icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .file_info {
    flex: 1;
  }

  .file_title {
    font-size: 14px;
    color: #4e555b;
  }

  .file_size {
    font-size: 12px;
    color: #83878a;
  }

  .box-card {
    position: relative;
  }

  .collect_icon {
    position: absolute;
    left: 20px;
    top: 0;
    z-index: 9;
  }

  .notice_issuer {
    font-size: 16px;
    margin: 10px 0;
    text-align: center;
  }

  .notice_timer {
    font-size: 14px;
    color: #4e555b;
    text-align: center;
  }

  .notice_file {
    border: 1px solid #eaf1ff !important;
  }

  /deep/ .notice_file .el-card__header {
    background-color: #eaf1ff;
    padding: 10px 20px;
  }

  /deep/ .el-card {
    border: none;
  }
</style>
